import { render, staticRenderFns } from "./text-tiles.vue?vue&type=template&id=6843b03b&scoped=true&"
import script from "./text-tiles.vue?vue&type=script&lang=js&"
export * from "./text-tiles.vue?vue&type=script&lang=js&"
import style0 from "./text-tiles.vue?vue&type=style&index=0&id=6843b03b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6843b03b",
  null
  
)

export default component.exports